var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.show
        ? _c("div", { staticClass: "c-tabs t-margin-bottom-m c-vue-tabs" }, [
            _c(
              "ul",
              { staticClass: "o-list-inline c-tabs__list" },
              _vm._l(_vm.tabs, function(tab, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "o-list-inline__item c-tabs__item",
                    class: { "c-tabs__item--active": _vm.currentTab === tab }
                  },
                  [
                    index === 1 ? _vm._t("notify") : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "c-tabs__title",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handleClick(tab)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t" + _vm._s(tab) + "\n\t\t\t\t")]
                    )
                  ],
                  2
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tabs, function(tab) {
        return _vm.currentTab === tab
          ? _c(
              "div",
              { key: tab, staticClass: "tab-content" },
              [_vm._t(tab)],
              2
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }